function areStringsEqual(str1: string, str2: string) {
  return str1.trim().toLowerCase() === str2.trim().toLowerCase();
}

export default areStringsEqual;
